import React,{useEffect, useMemo} from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Box,
  Slider,
  Typography,
  Divider,
  Stack,
} from "@mui/material";
import {
  fetchprompts,
  triggerCreatePrompt,
} from "../../../../store/slices/prompts";
import { useDispatch } from "react-redux";
import _ from 'lodash'
import { llmList } from "../constant";
import { getDefailtGpt5xVal, hasLowReasoningEffortFloor, normalizeReasoningEffort } from "../../../../common/utils";

const AddPrompt = ({
  open,
  handleClose,
  selectedCompany,
  type = "Response",
  isSentiment,
}) => {
  const [name, setName] = React.useState("");
  const [llm, setLlm] = React.useState("gpt-4o");
  const [version, setVersion] = React.useState(null);
  const [subType, setSubType] = React.useState(null);
  const [description, setDescription] = React.useState("");
  const [promptText, setPromptText] = React.useState("");
  const [systemPrompt, setSystemPrompt] = React.useState("");
  const [reasoning_effort, setReasoningEffort] = React.useState('medium');
  const [verbosity, setVerbosity] = React.useState('medium');
  const [temperature, setTemperature] = React.useState(0);
  const [inputFactor, setInputFactor] = React.useState(40);
  const [jsonResponse, setJsonResponse] = React.useState(false);
  const [presencePenalty, setPresencePenalty] = React.useState(0);
  const [maxLength, setMaxLength] = React.useState(500);
  const [frequencyPenalty, setFrequencyPenalty] = React.useState(0);
  const [topP, setTopP] = React.useState(1);

  const dispatch = useDispatch();
  const handleSliderChange = (slider) => (event, newValue) => {
    switch (slider) {
      case "temperature":
        setTemperature(newValue);
        break;
      case "presencePenalty":
        setPresencePenalty(newValue);
        break;
      case "maxLength":
        setMaxLength(newValue);
        break;
      case "frequencyPenalty":
        setFrequencyPenalty(newValue);
        break;
      case "inputFactor":
        setInputFactor(newValue);
        break;
      case "topP":
        setTopP(newValue);
        break;
      default:
        break;
    }
  };
  const subTypeMemo=useMemo(()=>{
    switch (type) {
      case 'Phrase Summary':
        return ['Category','Topic']
        case 'Response':
          return ['With Text','Without Text','Determine Names']
      default:
        return []
        break;
    }
  },[type])
  const handleAddClick = () => {
    let obj = {
      name: name,
      type: isSentiment ? "Sentiments" : type,
      description: description,
      reviewSelectionType: "Single",
      promptText: promptText,
      systemPrompt: systemPrompt,
      llm: llm,
      version:version,
      processSingleReview: false,
      defaultParameters: JSON.stringify({
        verbosity: verbosity,
        reasoning_effort: normalizeReasoningEffort(llm, reasoning_effort),
        temperature: temperature,
        inputFactor: inputFactor,
        jsonResponse: jsonResponse,
        maxLength: maxLength,
        presencePenalty: presencePenalty,
        frequencyPenalty: frequencyPenalty,
        topP: topP
      }),
    };
    dispatch(triggerCreatePrompt(selectedCompany, obj));
    setTimeout(() => {
      dispatch(fetchprompts(selectedCompany));
    }, 1000);
    handleClose();
  };

  // useEffect(()=>{
    
  //   if(llm==="gpt-5.1" || llm==="gpt-5.2"){
  //      setReasoningEffort('none')
  //   }else if (llm==="gpt-5-nano"){
  //     setReasoningEffort('minimal')
  //   }
  //   else{
  //     setReasoningEffort('medium')
  //   }
  // },[llm])
  return (
    <Dialog open={open} maxWidth="xl" fullWidth onClose={handleClose}>
      <DialogTitle>Add Prompt</DialogTitle>
      <Divider />
      <DialogContent>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            <TextField
              label="Name"
              size="small"
              value={name}
              onChange={(e) => setName(e.target.value)}
              fullWidth
              sx={{marginBottom:2}}
            />
          <FormControl variant="outlined" fullWidth sx={{marginBottom:2}}>
            <InputLabel>Sub Type</InputLabel>
            <Select
              label="Sub Type"
              size="small"
               value={!_.isEmpty(subType)?subType:null}
                disabled={_.size(subTypeMemo)<1}
               onChange={(e) => setSubType(e.target.value)}
            >
              {_.map(subTypeMemo,it=><MenuItem value={it}>{_.startCase(it)}</MenuItem>)}
              
              
            </Select>
          </FormControl>
          <FormControl  variant="outlined" fullWidth sx={{marginBottom:2}}>
            <InputLabel>LLM</InputLabel>
            <Select
              label="LLM"
              size="small"
              value={llm}
              onChange={(e) => setLlm(e.target.value)}
              
            >
               {_.map(llmList, llm => <MenuItem key={llm} value={llm}>{llm}</MenuItem>)}
            </Select>
          </FormControl>
            <TextField
              label="Version"
              size="small"
              value={version ? version : ""}
              fullWidth
              onChange={(e) => setVersion(e.target.value)}
              sx={{marginBottom:2}}
            />
            <TextField
              label="Description"
              multiline
              rows={3}
              size="small"
              value={description ?? ""}
              onChange={(e) => setDescription(e.target.value)}
              fullWidth
              sx={{marginBottom:2}}
            />
            <Box
              // border={1}
              // borderColor="lightgray"
              // borderRadius={4}
              // p={2}
              
              position="relative"
            >
              {/* <Typography
                variant="subtitle1"
                align="center"
                style={{
                  position: "absolute",
                  top: "-16px",
                  left: "50%",
                  transform: "translateX(-124%)",
                  backgroundColor: "white",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  color: "gray",
                  fontSize: "14px",
                }}
              >
                Default Parameters
              </Typography> */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  columnGap: "16px",
                  rowGap:'8px'
                }}
              >

                 <FormControl size="small" fullWidth>
                  <InputLabel>Verbosity</InputLabel>
                  <Select value={verbosity} label='Verbosity' onChange={e => setVerbosity(e.target.value)}>
                    <MenuItem value='low'>Low</MenuItem>
                    <MenuItem value='medium'>Medium</MenuItem>
                    <MenuItem value='high'>High</MenuItem>
                  </Select>
                </FormControl>

                <FormControl size="small" fullWidth>
                  <InputLabel>Reasoning Effort</InputLabel>
                  <Select value={reasoning_effort} label='Reasoning Effort' onChange={e => setReasoningEffort(e.target.value)}>
                    {!hasLowReasoningEffortFloor(llm) && <MenuItem value={getDefailtGpt5xVal(llm)}>{getDefailtGpt5xVal(llm) === 'none' ? 'None' : 'Minimal'}</MenuItem>}
                    <MenuItem value='low'>Low</MenuItem>
                    <MenuItem value='medium'>Medium</MenuItem>
                    <MenuItem value='high'>High</MenuItem>
                  </Select>
                </FormControl>
                <div>
                  <Typography>Temperature</Typography>
                  <Slider
                    value={temperature}
                    size="small"
                    min={0}
                    max={1}
                    step={0.01}
                    onChange={handleSliderChange("temperature")}
                    valueLabelDisplay="auto"
                  />
                </div>
                <div>
                  <Typography>Presence Penalty</Typography>
                  <Slider
                    value={presencePenalty}
                    size="small"
                    min={0}
                    max={2}
                    step={0.01}
                    onChange={handleSliderChange("presencePenalty")}
                    valueLabelDisplay="auto"
                  />
                </div>
                <div>
                  <Typography>Max Input Length</Typography>
                  <Slider
                    value={maxLength}
                    size="small"
                    min={128}
                    max={4096}
                    step={1}
                    onChange={handleSliderChange("maxLength")}
                    valueLabelDisplay="auto"
                  />
                </div>
                <div>
                  <Typography>Frequency Penalty</Typography>
                  <Slider
                    value={frequencyPenalty}
                    size="small"
                    min={0}
                    max={2}
                    step={0.01}
                    onChange={handleSliderChange("frequencyPenalty")}
                    valueLabelDisplay="auto"
                  />
                </div>
                <div>
                  <Typography>Top p</Typography>
                  <Slider
                    value={topP}
                    size="small"
                    min={0}
                    max={1}
                    step={0.1}
                    onChange={handleSliderChange("topP")}
                    valueLabelDisplay="auto"
                  />
                </div>
                {/* <div>
                  <Typography>Input Factor</Typography>
                  <Slider
                    value={inputFactor}
                    size="small"
                    min={10}
                    max={100}
                    step={5}
                    onChange={handleSliderChange("inputFactor")}
                    valueLabelDisplay="auto"
                  />
                </div> */}
              </div>
            </Box>
          </div>
          <TextField
            label="Prompt"
            style={{ marginLeft: "35px" }}
            placeholder="Prompt Text"
            multiline
            rows={18.6}
            size="small"
            value={promptText ?? ""}
            onChange={(e) => setPromptText(e.target.value)}
            fullWidth
            sx={{marginBottom:2}}
          />
        </div>
      </DialogContent>
      <Divider />
      <DialogActions
        sx={{ display: "flex", justifyContent: "start", my: 1, px: 3 }}
      >
        <Button
          onClick={handleAddClick}
          variant="contained"
          size="small"
          color="primary"
          disabled={
            selectedCompany?.trim === "" ||
            selectedCompany == null ||
            selectedCompany == undefined ||
            name.trim() === "" ||
            promptText.trim() === ""
          }
        >
          Add
        </Button>
        <Button
          onClick={handleClose}
          size="small"
          variant="outlined"
          color="secondary"
          sx={{ ml: 2 }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddPrompt;
